import { render, staticRenderFns } from "./SwitchAndMultipleSelection.vue?vue&type=template&id=31865a68&scoped=true"
import script from "./SwitchAndMultipleSelection.vue?vue&type=script&lang=js"
export * from "./SwitchAndMultipleSelection.vue?vue&type=script&lang=js"
import style0 from "./SwitchAndMultipleSelection.vue?vue&type=style&index=0&id=31865a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31865a68",
  null
  
)

export default component.exports